var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500", lazy: "" },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.load.pendingSchedule.title) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "px-3", attrs: { column: "" } },
            [
              _c("v-flex", [
                _c("label", [
                  _c("b", [_vm._v("Load Count:")]),
                  _vm._v(" " + _vm._s(_vm.load.pendingSchedule.loadCount))
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c("label", [
                  _c("b", [_vm._v("Scheduled pickup date:")]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("formatDay")(_vm.load.pendingSchedule.date)
                      ) +
                      "\n          " +
                      _vm._s(_vm.load.pendingSchedule.localPickupTime) +
                      "\n          "
                  ),
                  _c("i", [
                    _vm._v(
                      "(" + _vm._s(_vm.load.pendingSchedule.localTimezone) + ")"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c("label", [
                  _c("b", [_vm._v("From:")]),
                  _vm._v(" " + _vm._s(_vm.fromRegion))
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("label", [
                  _c("b", [_vm._v("To:")]),
                  _vm._v(" " + _vm._s(_vm.toRegion))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "accent" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("repeat", _vm.load)
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [_vm._v("sync")]),
                      _vm._v("\n          Repeat load\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        flat: "",
                        to: {
                          name: "company.loads.repeat.section",
                          params: {
                            id: _vm.companyId,
                            repeatLoadId: _vm.load.humanId
                          }
                        },
                        color: "accent"
                      },
                      on: {
                        click: function($event) {
                          _vm.openDialog = false
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [_vm._v("edit")]),
                      _vm._v("\n          View/Edit\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2348c5d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2348c5d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/dialogs/ScheculeLoadCalendarDialog.vue
// module id = null
// module chunks = 